import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {RestBackendService} from "../../service/rest-backend.service";
import {Router} from "@angular/router";
import {ConfirmationService, MessageService} from "primeng/api";
import {GlobalService} from "../../service/global.service";
import {ConfigService} from "../../service/config.service";
import {AdminUser} from "../../dto/AdminUser";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent  implements OnInit {
  userName: string="";
  password: string ="";
  @ViewChild("username") usernameField: ElementRef | undefined;


  constructor(protected restBack: RestBackendService,
              public route: Router,
              protected messageService: MessageService,
              protected confirmationService: ConfirmationService,
              public global: GlobalService,
              protected  config: ConfigService
  )  { }

  ngOnInit(): void {
    setTimeout(() => {
      // @ts-ignore
      this.usernameField.nativeElement.focus();
    }, 500);
  }

  login() {
      var observable = this.restBack.doGet("doc/user/login" +
        "?username=" + this.userName+
        "&password=" + this.password
      );
      observable.then((result: any) => {
        var status = result["status"];
        if (status == 200) {
          this.global.setCluster(result["cluster"]);
          var user:AdminUser = result["entity"]["user"];
          if (user != null &&user.id != null && user.id >0) {
            this.global.setUser(user);
            this.route.navigate(['/dashboard']);
          }else {
            this.messageService.clear();
            this.messageService.add({
              severity: 'error',
              summary:'ورود',
              detail:'ورود ناموفق بود'
            });
          }
        }else if(status == 401) {
          this.messageService.clear();
          this.messageService.add({
            severity: 'error',
            summary:'ورود',
            detail:'نام کاربری یا کلمه عبور اشتباه است.'
          });
        }

      });

  }
}
